module.exports = __webpack_public_path__ + "static/hpe_aruba_r_pos_rgb-4f45e2bdd330ca8e024999530b5ea021.png";